// dependencies
import { useState } from "react";
// import { useParams } from "react-router";

// @mui material components
import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "../components/MDBox";

// css
import "../assets/CSS/index.css";
import { LBInput } from "../components/lbic_component/LBIC_Input";
import LbicButton from "../components/lbic_component/LbicButton";

function MakePayment() {
  const [billingDetails, setBillingDetails] = useState({});

  return (
    <>
      <MDBox mt={8} className='top'>
        <MDBox mb={3}>
          <Card className="normal-container">
            <CardHeader
              component={Typography}
              title="Payment"
              sx={{ textAlign: "center" }}
            />
            <CardContent className="d-flex flex-column align-items-center">
              <LBInput
                inputType="text"
                variant="outlined"
                width="w-50"
                textType="text"
                label="Owner's Name"
                labelTop={true}
                setText={setBillingDetails}
                text={billingDetails}
                labelName="ownersname"
              />

              <LBInput
                inputType="text"
                variant="outlined"
                width="w-50"
                textType="text"
                label="Property Details"
                labelTop={true}
                setText={setBillingDetails}
                text={billingDetails}
                labelName="propertydetails"
              />
              <LbicButton title='Make Payment' color='success' onClick={() => alert(Object.values(billingDetails))} />
            </CardContent>
          </Card>
        </MDBox>
      </MDBox>
    </>
  );
}

export default MakePayment;
